import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import useFlowContext from "../context/useFlowContext";

var FlowStep = function FlowStep(_ref) {
  var children = _ref.children,
      id = _ref.id,
      name = _ref.name,
      component = _ref.component;

  var _useFlowContext = useFlowContext(),
      currentStep = _useFlowContext.currentStep,
      steps = _useFlowContext.steps,
      contextProps = _objectWithoutProperties(_useFlowContext, ["currentStep", "steps"]);

  var step = steps.find(function (item) {
    return item.id === id;
  });
  var stepIndex = steps.findIndex(function (item) {
    return item.id === id;
  });

  var renderProps = _objectSpread(_objectSpread({
    id: id,
    name: name,
    active: currentStep.id === id,
    isFirst: stepIndex === 0,
    isLast: stepIndex === steps.length - 1,
    touched: Boolean(step && step.touched)
  }, contextProps), {}, {
    children: children
  });

  var childrenWithRenderProps = React.Children.map(children, function (child) {
    if (! /*#__PURE__*/React.isValidElement(child) || typeof child.type === "string") {
      return child;
    }

    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), renderProps));
  });

  if (component) {
    return component(renderProps);
  }

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, childrenWithRenderProps);
};

export default FlowStep;